import React, { useEffect, useState, useCallback } from "react";

import { Field } from "formik";

import {
  Flex,
  Text,
  Divider,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
} from "@chakra-ui/react";

import TipoServicoAcolhimentoService from "../../../../../main/services/TipoServicoAcolhimentoService";
import CustomSelect from "../../../../components/CustomSelect";

const Caracterizacao = ({ formProps, modalidades, setModalidades }) => {
  const [regimes, setRegimes] = useState({ options: [], isLoading: false });
  const { values, setFieldValue } = formProps;

  const pesquisarModalidades = useCallback(
    (regimeValue) => {
      setModalidades((prev) => ({ ...prev, isLoading: true }));
      TipoServicoAcolhimentoService.pesquisarModalidades(regimeValue).then(
        (res) => {
          const tempData = res.data.map((modalidade) => {
            return { label: modalidade, value: modalidade };
          });
          setModalidades({ options: tempData, isLoading: false });
          if (regimeValue === "SAF") {
            setFieldValue("modalidade", tempData[0] || "");
          }
        }
      );
    },
    [setFieldValue, setModalidades]
  );

  useEffect(() => {
    if (values.regime.value !== "") {
      pesquisarModalidades(values.regime.value);
    }
  }, [values.regime.value, pesquisarModalidades]);

  const handleGetRegimes = () => {
    setRegimes({ ...regimes, isLoading: true });
    TipoServicoAcolhimentoService.pesquisarTipoServicoAcolhimento(
      "",
      "ativos",
      ""
    ).then((res) => {
      const tempRegimes = res.data.map((tsa) => tsa.regime);
      let tempRegimesFinal = [];
      if (tempRegimes.find((regime) => regime === "SAI")) {
        tempRegimesFinal = ["SAI"];
      }
      if (tempRegimes.find((regime) => regime === "SAF")) {
        tempRegimesFinal = [...tempRegimesFinal, "SAF"];
      }
      if (tempRegimesFinal.length === 2) {
        tempRegimesFinal = ["SAF", "SAI"];
      }
      const tempData = tempRegimesFinal.map((regime) => {
        if (regime === "SAI") {
          return {
            label: "Serviço de Acolhimento Institucional",
            value: regime,
          };
        } else {
          return { label: "Serviço de Acolhimento Familiar", value: regime };
        }
      });
      setRegimes({ options: tempData, isLoading: false });
    });
  };

  return (
    <Flex
      flexDir="column"
      mt="15px"
      pl="10px"
      pr="30px"
      py="16px"
      bgColor="#FFF"
      borderRadius="8px"
    >
      <Text
        color="#169499"
        fontWeight="700"
        fontSize="14px"
        lineHeight="19.6px"
      >
        {"Caracterização do Serviço de Acolhimento".toUpperCase()}
      </Text>
      <Divider mt="10px" orientation="horizontal" />
      <Grid
        mt="15px"
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(1, 1fr)",
          lg: "repeat(3, 1fr)",
          xl: "repeat(3, 1fr)",
        }}
        gap="15px"
      >
        <GridItem colSpan={1}>
          <Field name="naturezaServico">
            {({ field, form }) => (
              <FormControl
                name="naturezaServico"
                isInvalid={
                  form.errors.naturezaServico && form.touched.naturezaServico
                }
                id="naturezaServico"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="naturezaServico"
                >
                  Natureza*
                </FormLabel>
                <CustomSelect
                  isInvalid={
                    form.errors.naturezaServico && form.touched.naturezaServico
                  }
                  value={
                    [
                      { label: "Pública", value: "publica" },
                      { label: "Privada", value: "privada" },
                    ].find(
                      (option) =>
                        (formProps.values.naturezaServico || "")
                          .normalize("NFD")
                          .replace(/[̀-ͯ]/g, "")
                          .toLowerCase() === option.value
                    ) || ""
                  }
                  searchable={true}
                  options={[
                    { label: "Pública", value: "publica" },
                    { label: "Privada", value: "privada" },
                  ]}
                  placeholder="Escolha a Natureza"
                  onChange={(value) => {
                    formProps.setFieldValue(
                      "naturezaServico",
                      value ? value.value : ""
                    );
                  }}
                />
                <FormErrorMessage>
                  {form.errors.naturezaServico}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={1}>
          <Field name="regime">
            {({ field, form }) => (
              <FormControl
                name="regime"
                isInvalid={form.errors.regime && form.touched.regime}
                id="regime"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="regime"
                >
                  Regime*
                </FormLabel>

                <CustomSelect
                  isInvalid={form.errors.regime && form.touched.regime}
                  value={formProps.values.regime || ""}
                  options={regimes.options}
                  placeholder="Escolha o Regime"
                  onChange={(value) => {
                    formProps.setFieldValue("regime", value ? value : "");
                    if (
                      value?.value !== "SAF" &&
                      value?.value !== formProps?.values?.regime?.value
                    ) {
                      formProps.setFieldValue("modalidade", "");
                    }
                  }}
                  onFocus={
                    regimes.options.length === 0 ? handleGetRegimes : null
                  }
                />
                <FormErrorMessage>{form.errors.regime}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={1}>
          <Field name="modalidade">
            {({ field, form }) => (
              <FormControl
                name="modalidade"
                isInvalid={form.errors.modalidade && form.touched.modalidade}
                id="modalidade"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="modalidade"
                >
                  Modalidade*
                </FormLabel>
                <CustomSelect
                  isInvalid={form.errors.modalidade && form.touched.modalidade}
                  value={formProps.values.modalidade || ""}
                  searchable={true}
                  autoload={false}
                  isLoading={modalidades.isLoading}
                  options={modalidades.options}
                  isDisabled={values.regime.value === "SAF"}
                  placeholder="Escolha a Modalidade"
                  onChange={(value) => {
                    formProps.setFieldValue("modalidade", value);
                  }}
                />
                <FormErrorMessage>{form.errors.modalidade}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
      </Grid>
    </Flex>
  );
};

export default Caracterizacao;
